import {Component, OnInit} from '@angular/core';
import {HhgBillOfLadingService} from 'src/app/services/hhg-bill-of-lading/hhg-bill-of-lading.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {tap} from 'rxjs/operators';
import AppConstants, {BookShipmentStatus} from 'src/app/shared/common-components/AppConstants';
import {
  BolCorrectionNoticeEntity,
  HhgBillOfLadingDetails,
  HhgBolPackagesEntity
} from 'src/app/shared/common-components/common-structure';
import {LoadingService} from '../../services/loading/loading.service';
import {BillOfLadingService} from '../../services/bill-of-lading/bill-of-lading.service';
import {AlertService} from '../../services/alert/alert.service';
import {DatePipe} from '@angular/common';
import {saveAs} from 'file-saver';

@Component({
    selector: 'app-hhg-bill-of-lading',
    templateUrl: './hhg-bill-of-lading.component.html',
    styleUrls: ['./hhg-bill-of-lading.component.css'],
    standalone: false
})
export class HhgBillOfLadingComponent implements OnInit {
  billOfLadingObject: any;
  showStep: Boolean = false;
  customClass = 'customClass';
  isFirstOpen = true;
  billOfLadingForm: UntypedFormGroup;
  generateLabel = 'Generate Bill Of Lading';
  previewLabel = 'Preview Bill Of Lading';
  createDate: any;
  details: any;
  details1: any;
  hhgBillOfLadingDetails: HhgBillOfLadingDetails;
  private tmssloader;
  viewBillOfLadingPDF: boolean;
  bolNumberExists: boolean;
  billOfLadingNbr: string;
  fromGenerateOrView: string;
  shipmentInfoIdFromUrl: number;
  bookshipmentIdFromUrl: number;
  shipmentType: string;
  screenRoutedFrom: 'bol';
  shipmentTypeArray: any[];
  isHHGSelected: boolean;
  isPOVSelected: boolean;
  isUABSelected: boolean;
  selectedShipmentType: string;
  selectedVehicleType: string;
  isSaveForPDF: boolean;
  additionalRemarks: string;


  hhgBillOfLadingReview$ = this.hhgBillOfLadingService.hhgBillOfLadingReview$
    .pipe(
      tap(hhgBillOfLadingDetail => {
        this.details = hhgBillOfLadingDetail;
        if (hhgBillOfLadingDetail.billOfLadingNbr == 'undefined') {
          this.billOfLadingNbr = null;
        }
        if (hhgBillOfLadingDetail.billOfLadingNbr != 'undefined' && hhgBillOfLadingDetail.billOfLadingNbr != null && hhgBillOfLadingDetail.billOfLadingNbr != '') {
          this.bolNumberExists = true;
          this.billOfLadingNbr = hhgBillOfLadingDetail.billOfLadingNbr;
        }
        if (hhgBillOfLadingDetail && hhgBillOfLadingDetail.billOfLadingStatus &&
          hhgBillOfLadingDetail.billOfLadingStatus.toLocaleLowerCase()
          === BookShipmentStatus.COMPLETE.toLocaleLowerCase()) {
          this.generateLabel = 'Generate Correction Notice';
          this.previewLabel = 'Preview Correction Notice';
        } else {
          this.generateLabel = 'Generate Bill Of Lading';
          this.previewLabel = 'Preview Bill Of Lading';
        }
        this.billOfLadingForm.patchValue(hhgBillOfLadingDetail);
        this.additionalRemarks = hhgBillOfLadingDetail.additionalRemarks;
        this.createDate = this.billOfLadingForm.get('bolIssuedDate');
        this.billOfLadingForm.get('bolIssuedDate')
          .patchValue(new Date(hhgBillOfLadingDetail.bolIssuedDate).toLocaleDateString());
        hhgBillOfLadingDetail['assignedAgent'] = hhgBillOfLadingDetail.assignedAgentFirstName + ' ' +
          hhgBillOfLadingDetail.assignedAgentLastName;
        this.shipmentType = hhgBillOfLadingDetail.shipmentType;
        this.selectedVehicleType = hhgBillOfLadingDetail.vehicleType;
        console.log('this.shipmentType : ' + this.shipmentType);
      }));

  ngOnInit() {
    this.shipmentInfoIdFromUrl = this.route.snapshot.queryParams['shipmentId'];
    this.bookshipmentIdFromUrl = this.route.snapshot.queryParams['bookshipmentid'];
    this.selectedShipmentType = this.route.snapshot.queryParams['selectedShipmentType'];
    if (this.selectedShipmentType) {
      this.shipmentTypeArray = this.selectedShipmentType.split(' & ');
      for (let i = 0; i < this.shipmentTypeArray.length; i++) {
        if (this.shipmentTypeArray[i] === 'HHG') {
          this.isHHGSelected = true;
        }
        if (this.shipmentTypeArray[i] === 'HHG-UAB') {
          this.isUABSelected = true;
        }
        if (this.shipmentTypeArray[i] === 'HHG-POV') {
          this.isPOVSelected = true;
        }
      }
    }
    this.hhgBillOfLadingService.updateShipmentId(this.route.snapshot.queryParams['shipmentId']);
  }

  constructor(private route: ActivatedRoute,
              private hhgBillOfLadingService: HhgBillOfLadingService,
              private formBuilder: UntypedFormBuilder,
              private loader: LoadingService,
              private billOfLadingService: BillOfLadingService,
              private alertService: AlertService,
              private router: Router) {
    this.tmssloader = this.loader;
    this.billOfLadingForm = this.formBuilder.group({
      shipmentsInfoId: new UntypedFormControl({value: '', disabled: true}),
      bookShipmentId: new UntypedFormControl({value: '', disabled: true}),
      billOfLadingNbr: new UntypedFormControl({value: '', disabled: true}),
      bolIssuedDate: new UntypedFormControl({value: '', disabled: true}),
      billOfLadingStatus: new UntypedFormControl({value: '', disabled: true}),
      billOfLadingInfo: [],
      billOfLadingShipmentInfo: [],
      billOfAccessorialInformation: [],
      billOfLadingShipmentFinalization: []
    });
  }

  saveBillOfLading() {
    this.tmssloader.show();
    const billOfLadingFormValue = this.billOfLadingForm.getRawValue();
    const hhgBillOfLadingDetails = {...new HhgBillOfLadingDetails(), ...billOfLadingFormValue.billOfLadingInfo, ...billOfLadingFormValue.billOfLadingInfo.bolDetails} as HhgBillOfLadingDetails;

    hhgBillOfLadingDetails.bolStatus = billOfLadingFormValue.billOfLadingStatus;
    hhgBillOfLadingDetails.bolNumber = billOfLadingFormValue.billOfLadingNbr;
    hhgBillOfLadingDetails.creationDate = this.details.bolIssuedDate;
    hhgBillOfLadingDetails.additionalRemarks = billOfLadingFormValue.billOfLadingShipmentFinalization.additionalRemarks;
    hhgBillOfLadingDetails.travelOrderDate = new DatePipe('en-US').transform(billOfLadingFormValue.billOfLadingInfo.bolDetails.travelOrderDateFormated, 'yyyy-MM-ddTHH:mm:ss.SSS');
    hhgBillOfLadingDetails.hhgBolPackagesEntityList = <HhgBolPackagesEntity[]>(billOfLadingFormValue.billOfLadingShipmentInfo.packages);
    if (AppConstants.isNotNullCondition(hhgBillOfLadingDetails.bolNumber)) {
      hhgBillOfLadingDetails.bolCorrectionNoticeEntity = <BolCorrectionNoticeEntity>(billOfLadingFormValue.billOfLadingShipmentFinalization);
    }
    console.log('hhg bol=', billOfLadingFormValue.billOfLadingShipmentFinalization);
    // const bolData = new BolCorrectionNoticeEntity();
    // bolData.bolCorrectionNoticeId = billOfLadingFormValue.billOfLadingShipmentFinalization.bolCorrectionNoticeId;
    // bolData.authorityForCorrection = billOfLadingFormValue.billOfLadingShipmentFinalization.authorityForCorrection;
    // bolData.correctionRemarks = billOfLadingFormValue.billOfLadingShipmentFinalization.correctionRemarks;
    // if(AppConstants.isNotNullCondition(bolData.authorityForCorrection) || AppConstants.isNotNullCondition(bolData.correctionRemarks)){
    //     hhgBillOfLadingDetails.bolCorrectionNoticeEntity= bolData;
    // }
    this.hhgBillOfLadingService.saveBolInfo(hhgBillOfLadingDetails)
      .subscribe
      (data => {
          console.log('createUser data=', data);
          if (!(data == null)) {
            this.tmssloader.hide();
            if (!this.isSaveForPDF) {
              this.alertService.success('BOL has been added/Updated Successfully.');
            }
          } else {
            console.log('Error createUser data');
            this.tmssloader.hide();
          }
        },
        err => {
          console.log('Error createUser data=', err);
          this.tmssloader.hide();
          this.alertService.error('Error occured while saving/Updating BOL.');
        });
  }

  generateBillOfLadingPDF(from?, shipment?) {
    this.tmssloader.show();
    // this.isSaveForPDF = true;
    // this.saveBillOfLading();
    if (from === 'generateHHG') {
      this.fromGenerateOrView = 'generateHHG';
    } else if (from === 'previewHHG') {
      this.fromGenerateOrView = 'previewHHG';
    }
    const billOfLadingFormValue = this.billOfLadingForm.getRawValue();
    const hhgBillOfLadingDetails = {...new HhgBillOfLadingDetails(), ...billOfLadingFormValue.billOfLadingInfo, ...billOfLadingFormValue.billOfLadingInfo.bolDetails} as HhgBillOfLadingDetails;
    hhgBillOfLadingDetails.bolStatus = billOfLadingFormValue.billOfLadingStatus;
    hhgBillOfLadingDetails.bolNumber = billOfLadingFormValue.billOfLadingNbr;
    hhgBillOfLadingDetails.creationDate = this.details.bolIssuedDate;
    hhgBillOfLadingDetails.additionalRemarks = billOfLadingFormValue.billOfLadingShipmentFinalization.additionalRemarks;
    hhgBillOfLadingDetails.shipmentTypeFromScreen = shipment;
    hhgBillOfLadingDetails.bookShipmentId = this.bookshipmentIdFromUrl;
    hhgBillOfLadingDetails.travelOrderDate = new DatePipe('en-US').transform(billOfLadingFormValue.billOfLadingInfo.bolDetails.travelOrderDateFormated, 'yyyy-MM-ddTHH:mm:ss.SSS');
    hhgBillOfLadingDetails.hhgBolPackagesEntityList = <HhgBolPackagesEntity[]>(billOfLadingFormValue.billOfLadingShipmentInfo.packages);
    if (AppConstants.isNotNullCondition(hhgBillOfLadingDetails.bolNumber)) {
      hhgBillOfLadingDetails.bolCorrectionNoticeEntity = <BolCorrectionNoticeEntity>(billOfLadingFormValue.billOfLadingShipmentFinalization);
    }
    //  const bolData = new BolCorrectionNoticeEntity();
    //  bolData.bolCorrectionNoticeId = billOfLadingFormValue.billOfLadingShipmentFinalization.bolCorrectionNoticeId;
    //  bolData.authorityForCorrection = billOfLadingFormValue.billOfLadingShipmentFinalization.authorityForCorrection;
    //  bolData.correctionRemarks = billOfLadingFormValue.billOfLadingShipmentFinalization.correctionRemarks;
    //  if(AppConstants.isNotNullCondition(bolData.authorityForCorrection) || AppConstants.isNotNullCondition(bolData.correctionRemarks)){
    //      hhgBillOfLadingDetails.bolCorrectionNoticeEntity= bolData;
    //  }
    this.viewBillOfLadingPDF = false;
    this.billOfLadingService.getBillOfLadingPDFData(hhgBillOfLadingDetails, this.fromGenerateOrView)
      .subscribe
      (callResp => {
        this.tmssloader.hide();
        this.saveDownloadResponse(callResp);
        this.alertService.success('PDF generated / downloaded successfully');
        if (this.fromGenerateOrView === 'generateHHG') {
          this.router.navigate(['/', 'shipmentcontrolreview'],
            {queryParams: {bookshipmentid: this.bookshipmentIdFromUrl, shipmentType: 'HHG'}});
        }
      }, (error) => {
        this.tmssloader.hide();
        this.alertService.error('Error Downloading Report');
        console.log('== Error => ', error);
      }, () => {
        this.tmssloader.hide();
      });
  }

  saveDownloadResponse(response: any) {
    if (response.length > 0) {
      response.forEach(downloadResponse => {
        console.log('== callResp => ', downloadResponse);
        const byteData: number[] = downloadResponse.byteData;
        const fileName: string = downloadResponse.fileName;
        const numRows: number = downloadResponse.numberOfExcelRows;
        const bytes = new Uint8Array(byteData);
        console.log('numRows:' + numRows);
        const blob = new Blob([bytes], {type: 'application/pdf'});
        const objectUrl = URL.createObjectURL(blob);
        window.open(objectUrl);
        saveAs(blob, fileName);
      });
    }
  }

  generateHHGCorrectionNoticePDF() {
    this.tmssloader.show();
    // this.isSaveForPDF = true;
    // this.saveBillOfLading();
    const billOfLadingFormValue = this.billOfLadingForm.getRawValue();
    const hhgBillOfLadingDetails = {...new HhgBillOfLadingDetails(), ...billOfLadingFormValue.billOfLadingInfo, ...billOfLadingFormValue.billOfLadingInfo.bolDetails} as HhgBillOfLadingDetails;
    hhgBillOfLadingDetails.bolStatus = billOfLadingFormValue.billOfLadingStatus;
    hhgBillOfLadingDetails.bolNumber = billOfLadingFormValue.billOfLadingNbr;
    hhgBillOfLadingDetails.additionalRemarks = AppConstants.isNotNullCondition(billOfLadingFormValue.billOfLadingShipmentFinalization) ?
      billOfLadingFormValue.billOfLadingShipmentFinalization.additionalRemarks : null;
    hhgBillOfLadingDetails.creationDate = this.details.bolIssuedDate;
    hhgBillOfLadingDetails.travelOrderDate = new DatePipe('en-US').transform(billOfLadingFormValue.billOfLadingInfo.bolDetails.travelOrderDateFormated, 'yyyy-MM-ddTHH:mm:ss.SSS');
    hhgBillOfLadingDetails.hhgBolPackagesEntityList = <HhgBolPackagesEntity[]>(billOfLadingFormValue.billOfLadingShipmentInfo.packages);

    hhgBillOfLadingDetails.bolCorrectionNoticeEntity = <BolCorrectionNoticeEntity>(billOfLadingFormValue.billOfLadingShipmentFinalization);
    // hhgBillOfLadingDetails.bolCorrectionNoticeEntity = <BolCorrectionNoticeEntity>(billOfLadingFormValue.billOfLadingShipmentFinalization);

    this.viewBillOfLadingPDF = false;
    this.billOfLadingService.getHHGCorrectionNoticePDFData(hhgBillOfLadingDetails)
      .subscribe
      (callResp => {
        this.saveDownloadResponse(callResp);
        this.tmssloader.hide();
      }, (error) => {
        this.tmssloader.hide();
        this.alertService.error('Error Downloading Report');
        console.log('== Error => ', error);
      }, () => {
        this.router.navigate(['/', 'shipmentcontrolreview'],
          {queryParams: {bookshipmentid: this.bookshipmentIdFromUrl, shipmentType: 'HHG'}});
      });
  }

  goBackToPreviousPage() {
    console.log('bookshipmentIdFromUrl : ' + this.bookshipmentIdFromUrl);
    this.router.navigate(['/', 'hhgbookshipment'], {
      queryParams:
        {bookshipmentid: this.bookshipmentIdFromUrl}
    });
  }
}
